module.exports = __webpack_public_path__ + "static/media/EnpossLogo.19e5429e.png";